import ShareableLinkName from './ShareableLinkName.component';

export default ShareableLinkName;